import { FC } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
} from '@chakra-ui/react';
import { CrawlerDetailFormFields } from '../../../types/crawlerDetailFormFields';
import { useAddDetailStore } from '../../../hooks';

type Props = {
  values: CrawlerDetailFormFields;
  handleClose: ReturnType<typeof useAddDetailStore>['onCloseModal'];
};

export const CrawlerAddDetailResultModalView: FC<Props> = ({
  values,
  handleClose,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">バージョンの追加</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl>
          <FormLabel>バージョン</FormLabel>
          <Input
            type="text"
            value={values.version}
            width="240px"
            variant="flushed"
            isReadOnly
            isTruncated
          />
        </FormControl>
      </Stack>
      <Text align="center" fontWeight="bold" mt="60px">
        バージョンの追加が完了しました
      </Text>
    </ModalBody>
    <ModalFooter justifyContent="center" mx="20px" gap="16px" p="40px">
      <Button
        w="140px"
        colorScheme="blackAlpha"
        variant="outline"
        onClick={handleClose}
      >
        閉じる
      </Button>
    </ModalFooter>
  </ModalContent>
);
